class MediaProgressBar extends HTMLElement {
  connectedCallback() {
    const gallery = this.closest('media-gallery');
    const slider = gallery && gallery.querySelector('.main-image carousel-slider');

    if (!slider) return;

    const status = this.querySelector('[data-media-progress-status]');
    const total = this.style.getPropertyValue('--media-progress-count');
    const ofText = this.dataset.ofText;

    slider.addEventListener('on:carousel-slider:select', (event) => {
      this.style.setProperty('--media-progress-index', event.detail.index);

      if (status) {
        status.textContent = `${event.detail.index + 1} ${ofText} ${total}`;
      }
    });
  }
}

customElements.define('media-progress-bar', MediaProgressBar);
